export default __webpack_public_path__ + "static/media/71.59369382.jpg";